import { z } from "zod";
import { LIMIT_DEFAULT, LIMIT_MAX, PAGE_DEFAULT } from "../constants.js";

// 共通エラー形式（[19] §1.3）。message は利用者向け日本語。
export const errorResponseSchema = z.object({
  error: z.object({
    code: z.string(),
    message: z.string(),
    details: z
      .array(
        z.object({
          path: z.string(),
          message: z.string(),
        }),
      )
      .default([]),
  }),
});
export type ErrorResponse = z.infer<typeof errorResponseSchema>;

// ページネーションのクエリ（[19] §1.5）。クエリは z.coerce で型変換・検証。
export const paginationQuerySchema = z.object({
  page: z.coerce.number().int().min(1).default(PAGE_DEFAULT),
  limit: z.coerce.number().int().min(1).max(LIMIT_MAX).default(LIMIT_DEFAULT),
});
export type PaginationQuery = z.infer<typeof paginationQuerySchema>;

// 一覧レスポンスの包み（items は各ドメインで指定）
export function listResponseSchema<T extends z.ZodTypeAny>(item: T) {
  return z.object({
    items: z.array(item),
    total: z.number().int(),
    page: z.number().int(),
    limit: z.number().int(),
  });
}

export const idParamSchema = z.object({ id: z.string().min(1) });
